import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'
import Mousetrap from 'mousetrap'

import SearchModal from './search-modal'
import SearchForm from './search-form'
import createStore from './store'
import { trackOpenQuickSearchModal } from './utils'

onDomLoad(($dom) => {
  const firmSearchBoxes = $dom
    .find("[data-behaviour~='quick-search/firm-search-box']")
    .get()
  const $navButton = $dom.find("[data-behaviour~='quick-search/nav-button']")

  // onDomLoad runs scoped to each loaded turbo frame; quick-search lives in the
  // navbar (never inside a frame), so only initialise when the current scope
  // actually contains it.
  if (!firmSearchBoxes.length && !$navButton.length) {
    return
  }

  const currentFirmId = $('#current_firm_id').val()
  const currentCompanyId = $('#current_company_id').val()

  const liveInputsElement = document.querySelector(
    "[data-behaviour='live-inputs']"
  )
  let templateOwnerId = null
  let templateOwnerType = null

  if (liveInputsElement) {
    templateOwnerId = liveInputsElement.getAttribute('data-owner-id')
    const ownerTypeAttr = liveInputsElement.getAttribute('data-owner-type')

    if (ownerTypeAttr === 'account_entry_id') {
      templateOwnerType = 'AccountEntry'
    } else if (ownerTypeAttr === 'reconciliation_text_id') {
      templateOwnerType = 'ReconciliationText'
    }
  }

  const searchStore = createStore({
    currentFirmId,
    currentCompanyId,
    templateOwnerId,
    templateOwnerType,
  })

  firmSearchBoxes.forEach((node) => {
    const searchFormApp = createApp(SearchForm, {
      isFullHeight: false,
      isInitiallyFocused: true,
      limit: 25,
    })

    searchFormApp.use(searchStore)

    searchFormApp.mount(node)
  })

  const isMac = navigator.userAgent.toUpperCase().includes('MAC')
  const shortcuts = {
    full: { mac: '⌘J', other: 'Ctrl+J' },
    short: { mac: '⌘', other: 'Ctrl' },
  }

  document
    .querySelectorAll("[data-behaviour='quick-search/mod-key']")
    .forEach((el) => {
      const type = el.dataset.fullShortcut ? 'full' : 'short'
      el.textContent = isMac ? shortcuts[type].mac : shortcuts[type].other
    })

  const focusOnSearch = function focusOnSearch() {
    if (!firmSearchBoxes.length) {
      searchStore.dispatch('toggleModal')
    } else {
      const firstSearchBox = firmSearchBoxes[0]
      const inputElement = firstSearchBox.querySelector('input[type="text"]')
      if (inputElement) {
        inputElement.focus()
        firstSearchBox.classList.add('sf-md-animation-zoom')
        setTimeout(() => {
          firstSearchBox.classList.remove('sf-md-animation-zoom')
        }, 600)
      }
    }
  }

  Mousetrap.bind('mod+j', () => {
    focusOnSearch()
    trackOpenQuickSearchModal()
    return false
  })

  if ($navButton.length) {
    $navButton.on('click', (event) => {
      event.preventDefault()
      focusOnSearch()
    })

    if (!firmSearchBoxes.length) {
      const $searchModalContainer = $dom
        .find("[data-behaviour='quick-search/search-modal']")
        .html('')
      const $div = $('<div>').appendTo($searchModalContainer)

      if ($searchModalContainer.length) {
        const searchModalApp = createApp(
          SearchModal,
          {},
          {
            singletonId: 'global-search-modal',
          }
        )

        searchModalApp.use(searchStore)

        searchModalApp.mount($div.get(0))
      }
    }
  }
})
